import React from 'react';
import { Grid } from '@material-ui/core';

import Description from 'components/typography/Description';
import MainTextfield from 'components/textfield/MainTextfield';

const ServingsInput = ({
  servings = '',
  setServings,
  errorMessage,
  readOnly = false,
}) => {
  const _setServings = (value) => {
    if (!value) setServings('');
    else setServings(parseInt(value));
  };

  return (
    <Grid container direction="column" spacing={1}>
      <Grid item style={{ marginBottom: 8 }}>
        <Description>
          <b>Servings</b>
        </Description>
      </Grid>

      <Grid item>
        <MainTextfield
          fullWidth={true}
          type="number"
          value={servings}
          onChange={(event) => _setServings(event.target.value)}
          label={'How many people does this recipe serve ?'}
          error={!!errorMessage}
          helperText={errorMessage}
          readOnly={readOnly}
          isPrimary={false}
        ></MainTextfield>
      </Grid>
    </Grid>
  );
};

export default ServingsInput;
